/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Auto_Insert_EventInputs */



/**
* | output |
* | --- |
* | "Automatically Insert New Event" |
*
* @param {Options_Editor_Auto_Insert_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_auto_insert_event = /** @type {((inputs?: Options_Editor_Auto_Insert_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Auto_Insert_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérer automatiquement un nouvel événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neues Ereignis automatisch einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci automaticamente un nuovo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическая вставка нового события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar automáticamente un nuevo evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动插入新事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいイベントを自動的に挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया इवेंट स्वचालित रूप से डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir novo evento automaticamente")
	return /** @type {LocalizedString} */ ("Automatically Insert New Event")
});